export default __webpack_public_path__ + "static/media/imagePlaceholder.5d18c6f5.svg";